module.exports = __webpack_public_path__ + "static/media/bike.c970862e.jpg";